import React from 'react'
import { useParams } from 'react-router'
// Component
import Select from './_Select'
import Detail from './_Detail'
// Additional
import { Phase } from 'helpers/app'
import { Routing } from 'helpers/routing'
import { MatchContext } from 'components/Matches/__Matches.context'

const Match: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.MatchParams>()

  return (
    <MatchContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </MatchContext.Provider>
  )
}

export default Match
